import { Box, InputAdornment, TextField } from "@mui/material";
import { QuickFilter, QuickFilterClear, QuickFilterControl } from "@mui/x-data-grid-pro";
import { MdsIcon } from "@sinch/components";
import { MdsClose, MdsSearch } from "@sinch/icons";
import type { PropsWithChildren } from "react";
import React from "react";

export const QuickSearchToolbar = ({ children }: PropsWithChildren) => (
  <Box
    sx={(theme) => ({
      display: "flex",
      justifyContent: "space-between",
      pt: 2,
      pb: 1,
      borderBottom: `1px solid ${theme.palette.divider}`,
      alignItems: "center",
    })}
  >
    <QuickFilter expanded>
      <QuickFilterControl
        render={({ ref, ...other }) => (
          <TextField
            {...other}
            aria-label="Search"
            inputRef={ref}
            placeholder="Search..."
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <MdsIcon fontSize="xs" icon={MdsSearch} />
                  </InputAdornment>
                ),
                endAdornment: other.value ? (
                  <InputAdornment position="end">
                    <QuickFilterClear
                      aria-label="Clear search"
                      edge="end"
                      material={{ sx: { marginRight: -0.75 } }}
                      size="small"
                    >
                      <MdsIcon fontSize="xs" icon={MdsClose} />
                    </QuickFilterClear>
                  </InputAdornment>
                ) : null,
                ...other.slotProps?.input,
              },
              ...other.slotProps,
            }}
            sx={{ width: 260, p: 0.5 }}
          />
        )}
      />
    </QuickFilter>
    {children}
  </Box>
);
